export default __webpack_public_path__ + "static/media/IT-Admin-Illustration.2e860abe.svg";